var router = require('pjax').Router;
var form = require('./form.js');
var index = require('./index.js');

router.get('judging/score-set/:any', form);
router.get('judging/score-set', index);
